class FitQuiz extends HTMLElement {
  constructor() {
    super();

    this.sizes = [
      'XS',
      'S',
      'M',
      'L',
      'XL',
      '2XL',
      '3XL',
    ];

    this.questionSets = {
      upper_body: [
        {
          key: 'usualSize',
          title: 'What size do you usually wear?',
          layout: 'sizes',
          answers: this.sizes.map((size) => ({
            label: size,
            value: size
          }))
        },
        {
          key: 'sizeConsistency',
          title: 'Do you always wear this size?',
          layout: 'stacked',
          answers: [
            {
              label: 'No, I sometimes wear a smaller size',
              value: 'smaller'
            },
            {
              label: 'Yes',
              value: 'same'
            },
            {
              label: 'No, I sometimes wear a bigger size',
              value: 'bigger'
            }
          ]
        },
        {
          key: 'stomach',
          title: 'What do you think is most like you?',
          layout: 'visual',
          answers: [
            { label: 'Flat', value: 'flat' },
            { label: 'Average', value: 'average' },
            { label: 'Round', value: 'round' }
          ]
        },
        {
          key: 'chest',
          title: 'How would you describe your chest?',
          layout: 'visual',
          answers: [
            { label: 'Slim', value: 'slim' },
            { label: 'Average', value: 'average' },
            { label: 'Broad', value: 'broad' }
          ]
        },
        {
          key: 'height',
          title: 'How tall are you?',
          layout: 'slider'
        },
        {
          key: 'preferredFit',
          title: 'What fit would you prefer for this item?',
          layout: 'stacked',
          answers: [
            { label: 'Slim fit', value: 'slim' },
            { label: 'Regular fit', value: 'regular' },
            { label: 'Loose fit', value: 'loose' }
          ]
        }
      ],

      bottoms: [
        {
          key: 'usualSize',
          title: 'What trouser size do you usually wear?',
          layout: 'sizes',
          answers: this.sizes.map((size) => ({
            label: size,
            value: size
          }))
        },
        {
          key: 'sizeConsistency',
          title: 'Do you always wear this size?',
          layout: 'stacked',
          answers: [
            {
              label: 'No, I sometimes wear a smaller size',
              value: 'smaller'
            },
            {
              label: 'Yes',
              value: 'same'
            },
            {
              label: 'No, I sometimes wear a bigger size',
              value: 'bigger'
            }
          ]
        },
        {
          key: 'waist',
          title: 'How would you describe your waist?',
          layout: 'visual',
          answers: [
            { label: 'Slim', value: 'slim' },
            { label: 'Average', value: 'average' },
            { label: 'Broad', value: 'broad' }
          ]
        },
        {
          key: 'hips',
          title: 'How would you describe your hips?',
          layout: 'visual',
          answers: [
            { label: 'Narrow', value: 'narrow' },
            { label: 'Average', value: 'average' },
            { label: 'Wide', value: 'wide' }
          ]
        },
        {
          key: 'height',
          title: 'How tall are you?',
          layout: 'slider'
        },
        {
          key: 'preferredFit',
          title: 'What fit would you prefer for this item?',
          layout: 'stacked',
          answers: [
            { label: 'Slim fit', value: 'slim' },
            { label: 'Regular fit', value: 'regular' },
            { label: 'Loose fit', value: 'loose' }
          ]
        }
      ],

      dresses: [
        {
          key: 'usualSize',
          title: 'What dress size do you usually wear?',
          layout: 'sizes',
          answers: this.sizes.map((size) => ({
            label: size,
            value: size
          }))
        },
        {
          key: 'sizeConsistency',
          title: 'Do you always wear this size?',
          layout: 'stacked',
          answers: [
            {
              label: 'No, I sometimes wear a smaller size',
              value: 'smaller'
            },
            {
              label: 'Yes',
              value: 'same'
            },
            {
              label: 'No, I sometimes wear a bigger size',
              value: 'bigger'
            }
          ]
        },
        {
          key: 'waist',
          title: 'How would you describe your waist?',
          layout: 'visual',
          answers: [
            { label: 'Slim', value: 'slim' },
            { label: 'Average', value: 'average' },
            { label: 'Broad', value: 'broad' }
          ]
        },
        {
          key: 'chest',
          title: 'How would you describe your bust?',
          layout: 'visual',
          answers: [
            { label: 'Slim', value: 'slim' },
            { label: 'Average', value: 'average' },
            { label: 'Full', value: 'broad' }
          ]
        },
        {
          key: 'height',
          title: 'How tall are you?',
          layout: 'slider'
        },
        {
          key: 'preferredFit',
          title: 'What fit would you prefer for this item?',
          layout: 'stacked',
          answers: [
            { label: 'Slim fit', value: 'slim' },
            { label: 'Regular fit', value: 'regular' },
            { label: 'Loose fit', value: 'loose' }
          ]
        }
      ]
    };

    this.weights = {
      sizeConsistency: {
        smaller: -0.3,
        same: 0,
        bigger: 0.3
      },

      stomach: {
        flat: -0.2,
        average: 0,
        round: 0.4
      },

      chest: {
        slim: -0.15,
        average: 0,
        broad: 0.35
      },

      waist: {
        slim: -0.15,
        average: 0,
        broad: 0.35
      },

      hips: {
        narrow: -0.15,
        average: 0,
        wide: 0.4
      },

      preferredFit: {
        slim: -0.3,
        regular: 0,
        loose: 0.45
      },

      productFit: {
        true_to_size: 0,
        runs_small: 0.35,
        runs_large: -0.35
      }
    };

    this.currentStep = 0;

    this.answers = {
      height: 180
    };

    this.productCategory = 'upper_body';
    this.productGender = 'female';
    this.recommendedSize = null;
    this.assetData = {};
    this.productData = null;
    this.i18n = {};

    this.boundHandleClick = this.handleClick.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    const productDataElement = this.querySelector(
      '[data-fit-quiz-product]'
    );

    const assetDataElement = this.querySelector(
      '[data-fit-quiz-assets]'
    );

    const i18nDataElement = this.querySelector(
      '[data-fit-quiz-i18n]'
    );

    if (!productDataElement) {
      console.warn('Fit quiz: product data was not found.');
      return;
    }

    try {
      this.productData = JSON.parse(
        productDataElement.textContent
      );
    } catch (error) {
      console.error(
        'Fit quiz: product data could not be read.',
        error
      );
      return;
    }

    try {
      this.assetData = assetDataElement
        ? JSON.parse(assetDataElement.textContent)
        : {};
    } catch (error) {
      console.error(
        'Fit quiz: illustration assets could not be read.',
        error
      );

      this.assetData = {};
    }

    try {
      this.i18n = i18nDataElement
        ? JSON.parse(i18nDataElement.textContent)
        : {};
    } catch (error) {
      console.error(
        'Fit quiz: translations could not be read.',
        error
      );

      this.i18n = {};
    }

    this.applyQuestionTranslations();

this.productCategory = [
  'upper_body',
  'bottoms',
  'dresses'
].includes(this.dataset.fitCategory)
  ? this.dataset.fitCategory
  : 'upper_body';

this.productGender =
  this.dataset.fitGender === 'male'
    ? 'male'
    : 'female';

    this.questions =
      this.questionSets[this.productCategory] ||
      this.questionSets.upper_body;

    this.overlay = this.querySelector(
      '[data-fit-quiz-overlay]'
    );

    this.titleElement = this.querySelector(
      '[data-fit-quiz-title]'
    );

    this.answersElement = this.querySelector(
      '[data-fit-quiz-answers]'
    );

    this.stepElement = this.querySelector(
      '[data-fit-quiz-step]'
    );

    this.backButton = this.querySelector(
      '[data-fit-quiz-back]'
    );

    this.questionScreen = this.querySelector(
      '[data-fit-quiz-question-screen]'
    );

    this.resultScreen = this.querySelector(
      '[data-fit-quiz-result]'
    );

    this.resultSizeElement = this.querySelector(
      '[data-fit-quiz-result-size]'
    );

    this.triggerText = this.querySelector(
      '[data-fit-quiz-trigger-text]'
    );

    this.eyebrowElement = this.querySelector(
      '[data-fit-quiz-eyebrow]'
    );

    this.resultTitleElement = this.querySelector(
      '[data-fit-quiz-result-title]'
    );

    this.resultCopyElement = this.querySelector(
      '[data-fit-quiz-result-copy]'
    );

    this.confidenceElement = this.querySelector(
      '[data-fit-quiz-confidence]'
    );

    this.yourSizeElement = this.querySelector(
      '[data-fit-quiz-your-size]'
    );

    this.addButton = this.querySelector(
      '[data-fit-quiz-add]'
    );

    this.redoButton = this.querySelector(
      '[data-fit-quiz-redo]'
    );

    this.dialogElement = this.querySelector(
      '[data-fit-quiz-dialog]'
    );

    this.closeButton = this.querySelector(
      '[data-fit-quiz-close]'
    );

    this.hangerIcon = this.querySelector(
  '[data-fit-quiz-hanger]'
);

this.verifiedIcon = this.querySelector(
  '[data-fit-quiz-verified]'
);

    this.errorElement = this.querySelector(
      '[data-fit-quiz-error]'
    );

    this.addEventListener(
      'click',
      this.boundHandleClick
    );

    document.addEventListener(
      'keydown',
      this.boundHandleKeydown
    );

    this.applyStaticTranslations();
    this.restoreProfile();
  }

  disconnectedCallback() {
    this.removeEventListener(
      'click',
      this.boundHandleClick
    );

    document.removeEventListener(
      'keydown',
      this.boundHandleKeydown
    );
  }


  translate(key, fallback = '') {
    return this.i18n?.[key] || fallback;
  }

  formatTranslation(key, replacements = {}, fallback = '') {
    let text = this.translate(key, fallback);

    Object.entries(replacements).forEach(([name, value]) => {
      text = text.replaceAll(`{${name}}`, String(value));
    });

    return text;
  }

  applyQuestionTranslations() {
    const titleKeys = {
      upper_body: {
        usualSize: 'questionUsualSize',
        sizeConsistency: 'questionSizeConsistency',
        stomach: 'questionStomach',
        chest: 'questionChest',
        height: 'questionHeight',
        preferredFit: 'questionPreferredFit'
      },
      bottoms: {
        usualSize: 'questionTrouserSize',
        sizeConsistency: 'questionSizeConsistency',
        waist: 'questionWaist',
        hips: 'questionHips',
        height: 'questionHeight',
        preferredFit: 'questionPreferredFit'
      },
      dresses: {
        usualSize: 'questionDressSize',
        sizeConsistency: 'questionSizeConsistency',
        waist: 'questionWaist',
        chest: 'questionBust',
        height: 'questionHeight',
        preferredFit: 'questionPreferredFit'
      }
    };

    const answerKeys = {
      smaller: 'answerSometimesSmaller',
      same: 'answerYes',
      bigger: 'answerSometimesBigger',
      flat: 'answerFlat',
      average: 'answerAverage',
      round: 'answerRound',
      slim: 'answerSlim',
      broad: 'answerBroad',
      narrow: 'answerNarrow',
      wide: 'answerWide',
      loose: 'answerLooseFit',
      regular: 'answerRegularFit'
    };

    Object.entries(this.questionSets).forEach(([category, questions]) => {
      questions.forEach((question) => {
        const titleKey = titleKeys?.[category]?.[question.key];

        if (titleKey) {
          question.title = this.translate(titleKey, question.title);
        }

        question.answers?.forEach((answer) => {
          let answerKey = answerKeys[answer.value];

          if (question.key === 'preferredFit' && answer.value === 'slim') {
            answerKey = 'answerSlimFit';
          }

          if (category === 'dresses' && question.key === 'chest' && answer.value === 'broad') {
            answerKey = 'answerFull';
          }

          if (answerKey) {
            answer.label = this.translate(answerKey, answer.label);
          }
        });
      });
    });
  }

  applyStaticTranslations() {
    if (this.triggerText) {
      this.triggerText.textContent = this.translate(
        'triggerOpen',
        'Click here and find your size'
      );
    }

    if (this.eyebrowElement) {
      this.eyebrowElement.textContent = this.translate(
        'eyebrow',
        'Take our Fit quiz'
      );
    }

    if (this.resultTitleElement) {
      this.resultTitleElement.textContent = this.translate(
        'resultTitle',
        'Your recommended size is'
      );
    }

    if (this.resultCopyElement) {
      this.resultCopyElement.textContent = this.translate(
        'resultCopy',
        'Based on your usual size, body shape and preferred fit.'
      );
    }

    if (this.confidenceElement) {
      this.confidenceElement.textContent = this.translate(
        'confidence',
        'Strong match based on your answers.'
      );
    }

    if (this.yourSizeElement) {
      this.yourSizeElement.textContent = this.translate(
        'yourSize',
        'YOUR SIZE'
      );
    }

    if (this.addButton) {
      this.addButton.textContent = this.translate(
        'addToCart',
        'Add to cart'
      );
    }

    if (this.redoButton) {
      this.redoButton.textContent = this.translate(
        'redo',
        'Redo the quiz'
      );
    }

    if (this.dialogElement) {
      this.dialogElement.setAttribute(
        'aria-label',
        this.translate('dialogLabel', 'Fit quiz')
      );
    }

    if (this.backButton) {
      this.backButton.setAttribute(
        'aria-label',
        this.translate('previousQuestion', 'Previous question')
      );
    }

    if (this.closeButton) {
      this.closeButton.setAttribute(
        'aria-label',
        this.translate('closeQuiz', 'Close fit quiz')
      );
    }
  }


  getStorageKey() {
    return `custom_fit_profile_${this.productGender}_${this.productCategory}`;
  }

  handleClick(event) {
    if (event.target.closest('[data-fit-quiz-open]')) {
      this.open();
      return;
    }

    if (event.target.closest('[data-fit-quiz-close]')) {
      this.close();
      return;
    }

    if (
      event.target === this.overlay &&
      event.target.matches('[data-fit-quiz-overlay]')
    ) {
      this.close();
      return;
    }

    if (event.target.closest('[data-fit-quiz-back]')) {
      this.previousStep();
      return;
    }

    const answerButton = event.target.closest(
      '[data-fit-answer]'
    );

    if (answerButton) {
      this.selectAnswer(
        answerButton.dataset.fitAnswer
      );
      return;
    }

    if (
      event.target.closest('[data-fit-height-next]')
    ) {
      this.nextStep();
      return;
    }

    if (
      event.target.closest('[data-fit-quiz-redo]')
    ) {
      this.redo();
      return;
    }

    if (
      event.target.closest('[data-fit-quiz-add]')
    ) {
      this.addRecommendedSizeToCart();
    }
  }

  handleKeydown(event) {
    if (
      event.key === 'Escape' &&
      this.overlay &&
      !this.overlay.hidden
    ) {
      this.close();
    }
  }

  open() {
    if (!this.overlay) {
      return;
    }

    this.overlay.hidden = false;
    document.body.classList.add('fit-quiz-open');

    if (this.recommendedSize) {
      this.showResult();
    } else {
      this.renderStep();
    }
  }

  close() {
    if (!this.overlay) {
      return;
    }

    this.overlay.hidden = true;
    document.body.classList.remove('fit-quiz-open');
  }

  renderStep() {
    const question = this.questions[this.currentStep];

    if (!question) {
      return;
    }

    this.questionScreen.hidden = false;
    this.resultScreen.hidden = true;

    this.titleElement.textContent = question.title;

    this.stepElement.textContent =
      `${this.translate('step', 'Step')} ${this.currentStep + 1}/${this.questions.length}`;

    this.backButton.hidden = this.currentStep === 0;

    this.answersElement.className =
      'fit-quiz__answers';

    this.answersElement.innerHTML = '';

    if (question.layout === 'stacked') {
      this.answersElement.classList.add(
        'fit-quiz__answers--stacked'
      );
    }

    if (question.layout === 'visual') {
      this.answersElement.classList.add(
        'fit-quiz__answers--visual'
      );
    }

    if (question.layout === 'sizes') {
      this.answersElement.classList.add(
        'fit-quiz__answers--sizes'
      );
    }

    if (question.layout === 'slider') {
      this.renderHeightSlider();
      return;
    }

    question.answers.forEach((answer) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'fit-quiz__answer';
      button.dataset.fitAnswer = answer.value;

      if (question.layout === 'visual') {
        button.classList.add(
          'fit-quiz__answer--visual'
        );

        button.innerHTML = `
          <span class="fit-quiz__illustration">
            ${this.getVisualIllustration(
              question.key,
              answer.value,
              answer.label
            )}
          </span>

          <span class="fit-quiz__answer-label">
            ${this.escapeHtml(answer.label)}
          </span>
        `;
      } else {
        button.textContent = answer.label;
      }

      if (
        this.answers[question.key] === answer.value
      ) {
        button.classList.add('is-selected');
      }

      this.answersElement.appendChild(button);
    });
  }

  getVisualIllustration(
    questionKey,
    value,
    answerLabel
  ) {
    const genderAssets =
      this.assetData?.[this.productGender] || {};

    const questionAssets =
      genderAssets?.[questionKey] || {};

    const imageUrl =
      questionAssets?.[value] || '';

    if (!imageUrl) {
      console.warn(
        'Fit quiz illustration missing:',
        {
          gender: this.productGender,
          questionKey,
          value
        }
      );

      return '';
    }

    const altText =
      `${answerLabel} ${questionKey}`;

    return `
      <img
        class="fit-quiz__illustration-image"
        src="${this.escapeHtml(imageUrl)}"
        alt="${this.escapeHtml(altText)}"
        loading="eager"
        decoding="async"
      >
    `;
  }

  escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = String(value || '');

    return element.innerHTML;
  }

  renderHeightSlider() {
    const height = Number(
      this.answers.height || 180
    );

    this.answersElement.innerHTML = `
      <div class="fit-quiz__slider-wrap">
        <p class="fit-quiz__imperial" data-fit-imperial>
          ${this.cmToImperial(height)}
        </p>

        <p class="fit-quiz__height-value">
          <span data-fit-height-value>${height}</span> cm
        </p>

        <input
          class="fit-quiz__range"
          data-fit-height-range
          type="range"
          min="145"
          max="210"
          step="1"
          value="${height}"
          aria-label="Height in centimeters"
        >

        <button
          type="button"
          class="fit-quiz__primary-button fit-quiz__next-button"
          data-fit-height-next
        >
          ${this.translate('next', 'Next')}
        </button>
      </div>
    `;

    const range = this.answersElement.querySelector(
      '[data-fit-height-range]'
    );

    if (!range) {
      return;
    }

    range.addEventListener('input', () => {
      const value = Number(range.value);

      this.answers.height = value;

      const heightValueElement =
        this.answersElement.querySelector(
          '[data-fit-height-value]'
        );

      const imperialElement =
        this.answersElement.querySelector(
          '[data-fit-imperial]'
        );

      if (heightValueElement) {
        heightValueElement.textContent = value;
      }

      if (imperialElement) {
        imperialElement.textContent =
          this.cmToImperial(value);
      }
    });
  }

  cmToImperial(cm) {
    const totalInches = Math.round(cm / 2.54);
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;

    return `${feet} ft ${inches} in`;
  }

  selectAnswer(value) {
    const question = this.questions[this.currentStep];

    if (!question) {
      return;
    }

    this.answers[question.key] = value;

    window.setTimeout(() => {
      this.nextStep();
    }, 120);
  }

  nextStep() {
    if (
      this.currentStep <
      this.questions.length - 1
    ) {
      this.currentStep += 1;
      this.renderStep();
      return;
    }

    this.finishQuiz();
  }

  previousStep() {
    if (this.currentStep === 0) {
      return;
    }

    this.currentStep -= 1;
    this.renderStep();
  }

  finishQuiz() {
    this.recommendedSize =
      this.calculateRecommendedSize();

    this.saveProfile();
    this.selectRecommendedVariantOnPage();
    this.showResult();
  }

  calculateRecommendedSize() {
    const baseSize = this.answers.usualSize;
    let baseIndex = this.sizes.indexOf(baseSize);

    if (baseIndex < 0) {
      baseIndex = this.getFallbackSizeIndex();
    }

    let score = 0;

    score +=
      this.weights.sizeConsistency[
        this.answers.sizeConsistency
      ] || 0;

    if (this.productCategory === 'bottoms') {
      score +=
        this.weights.waist[
          this.answers.waist
        ] || 0;

      score +=
        this.weights.hips[
          this.answers.hips
        ] || 0;
    } else if (
      this.productCategory === 'dresses'
    ) {
      score +=
        this.weights.waist[
          this.answers.waist
        ] || 0;

      score +=
        this.weights.chest[
          this.answers.chest
        ] || 0;
    } else {
      score +=
        this.weights.stomach[
          this.answers.stomach
        ] || 0;

      score +=
        this.weights.chest[
          this.answers.chest
        ] || 0;
    }

    score +=
      this.weights.preferredFit[
        this.answers.preferredFit
      ] || 0;

    score += this.getHeightAdjustment(
      Number(this.answers.height)
    );

    const fitProfile =
      this.dataset.fitProfile ||
      'true_to_size';

    score +=
      this.weights.productFit[fitProfile] ??
      this.weights.productFit.true_to_size;

    let adjustment = 0;

    if (score >= 0.75) {
      adjustment = 1;
    }

    if (score <= -0.75) {
      adjustment = -1;
    }

    const recommendedIndex = Math.max(
      0,
      Math.min(
        this.sizes.length - 1,
        baseIndex + adjustment
      )
    );

    return this.findClosestAvailableSize(
      this.sizes[recommendedIndex],
      adjustment
    );
  }

  getHeightAdjustment(height) {
    if (!Number.isFinite(height)) {
      return 0;
    }

    if (height < 165) {
      return -0.1;
    }

    if (height <= 174) {
      return -0.05;
    }

    if (height <= 189) {
      return 0;
    }

    if (height <= 199) {
      return 0.1;
    }

    return 0.2;
  }

  getAvailableSizes() {
    const sizeIndex = Number(
      this.productData.sizeOptionIndex
    );

    return [
      ...new Set(
        this.productData.variants
          .filter((variant) => variant.available)
          .map(
            (variant) =>
              variant.options[sizeIndex]
          )
          .filter(Boolean)
      )
    ];
  }

  findClosestAvailableSize(
    requestedSize,
    preferredDirection = 0
  ) {
    const availableSizes =
      this.getAvailableSizes();

    if (
      availableSizes.includes(requestedSize)
    ) {
      return requestedSize;
    }

    const requestedIndex =
      this.sizes.indexOf(requestedSize);

    if (requestedIndex < 0) {
      return requestedSize;
    }

    for (
      let distance = 1;
      distance < this.sizes.length;
      distance += 1
    ) {
      const higherSize =
        this.sizes[requestedIndex + distance];

      const lowerSize =
        this.sizes[requestedIndex - distance];

      const candidates =
        preferredDirection < 0
          ? [lowerSize, higherSize]
          : [higherSize, lowerSize];

      for (const candidate of candidates) {
        if (
          candidate &&
          availableSizes.includes(candidate)
        ) {
          return candidate;
        }
      }
    }

    return requestedSize;
  }

  getFallbackSizeIndex() {
    const availableSizes =
      this.getAvailableSizes();

    const firstKnownSize =
      availableSizes.find((size) =>
        this.sizes.includes(size)
      );

    return firstKnownSize
      ? this.sizes.indexOf(firstKnownSize)
      : 2;
  }

  updateTriggerState(hasRecommendation) {
  this.classList.toggle(
    'fit-quiz--recommended',
    hasRecommendation
  );

  if (this.hangerIcon) {
    this.hangerIcon.hidden = hasRecommendation;
  }

  if (this.verifiedIcon) {
    this.verifiedIcon.hidden = !hasRecommendation;
  }
}

  showResult() {
    this.questionScreen.hidden = true;
    this.resultScreen.hidden = false;
    this.backButton.hidden = true;
    this.stepElement.textContent = '';

    this.resultSizeElement.textContent =
      this.recommendedSize;

    this.triggerText.textContent =
      this.formatTranslation(
        'triggerRecommended',
        { size: this.recommendedSize },
        `We recommend size ${this.recommendedSize}`
      );
      this.updateTriggerState(true);
  }

  redo() {
    const previousHeight = Number(
      this.answers.height || 180
    );

    this.currentStep = 0;
    this.recommendedSize = null;

    this.answers = {
      height: previousHeight
    };

localStorage.removeItem(
  this.getStorageKey()
);

this.triggerText.textContent =
  this.translate(
    'triggerOpen',
    'Click here and find your size'
  );

this.updateTriggerState(false);
this.renderStep();
  }

  saveProfile() {
    const profile = {
      gender: this.productGender,
      category: this.productCategory,
      answers: this.answers,
      recommendedSize: this.recommendedSize
    };

    try {
      localStorage.setItem(
        this.getStorageKey(),
        JSON.stringify(profile)
      );
    } catch (error) {
      console.warn(
        'Fit quiz profile could not be saved.',
        error
      );
    }
  }

  restoreProfile() {
    try {
      const storedValue = localStorage.getItem(
        this.getStorageKey()
      );

      if (!storedValue) {
        return;
      }

      const stored = JSON.parse(storedValue);

      if (!stored || !stored.answers) {
        return;
      }

      this.answers = {
        height: 180,
        ...stored.answers
      };

      this.recommendedSize =
        this.calculateRecommendedSize();

if (this.recommendedSize) {
  this.triggerText.textContent =
    this.formatTranslation(
      'triggerRecommended',
      { size: this.recommendedSize },
      `We recommend size ${this.recommendedSize}`
    );

  this.updateTriggerState(true);
}

    } catch (error) {
      console.warn(
        'Fit quiz profile could not be restored.',
        error
      );
    }
  }

  getProductForm() {
    return (
      document.querySelector(
        `form[action*="/cart/add"][data-product-id="${this.productData.id}"]`
      ) ||
      this.closest('section')?.querySelector(
        'form[action*="/cart/add"]'
      ) ||
      document.querySelector(
        'form[action*="/cart/add"]'
      )
    );
  }

  getCurrentSelectedOptions() {
    const productForm = this.getProductForm();

    if (!productForm) {
      return null;
    }

    const variantInput =
      productForm.querySelector('[name="id"]');

    const selectedVariantId = Number(
      variantInput?.value
    );

    return (
      this.productData.variants.find(
        (variant) =>
          variant.id === selectedVariantId
      )?.options || null
    );
  }

  getRecommendedVariant() {
    const selectedOptions =
      this.getCurrentSelectedOptions();

    const sizeIndex = Number(
      this.productData.sizeOptionIndex
    );

    return this.productData.variants.find(
      (variant) => {
        if (!variant.available) {
          return false;
        }

        if (
          variant.options[sizeIndex] !==
          this.recommendedSize
        ) {
          return false;
        }

        if (!selectedOptions) {
          return true;
        }

        return variant.options.every(
          (option, optionIndex) => {
            if (optionIndex === sizeIndex) {
              return true;
            }

            return (
              option ===
              selectedOptions[optionIndex]
            );
          }
        );
      }
    );
  }

  selectRecommendedVariantOnPage() {
    const size = this.recommendedSize;

    if (!size) {
      return;
    }

    const productSection =
      this.closest('section') || document;

    const candidates = Array.from(
      productSection.querySelectorAll(
        'input[type="radio"], option'
      )
    );

    const matchingInput = candidates.find(
      (element) =>
        String(element.value).trim() === size
    );

    if (!matchingInput) {
      return;
    }

    if (
      matchingInput.tagName === 'OPTION'
    ) {
      const select =
        matchingInput.parentElement;

      select.value = matchingInput.value;

      select.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      return;
    }

    matchingInput.checked = true;

    matchingInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  async addRecommendedSizeToCart() {
    const variant =
      this.getRecommendedVariant();

    this.errorElement.hidden = true;

    if (!variant) {
      this.errorElement.textContent =
        this.translate(
          'unavailable',
          'This size is currently unavailable in the selected colour.'
        );

      this.errorElement.hidden = false;
      return;
    }

    const button = this.querySelector(
      '[data-fit-quiz-add]'
    );

    if (!button) {
      return;
    }

    const originalText =
      button.textContent;

    button.disabled = true;
    button.textContent = this.translate('adding', 'Adding...');

    try {
      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Cart request failed.'
        );
      }

      this.close();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:refresh')
      );
    } catch (error) {
      console.error(
        'Fit quiz cart error:',
        error
      );

      this.errorElement.textContent =
        this.translate(
          'addFailed',
          'The product could not be added. Please try again.'
        );

      this.errorElement.hidden = false;
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

if (!customElements.get('fit-quiz')) {
  customElements.define(
    'fit-quiz',
    FitQuiz
  );
}